import { useStoreError } from '@/stores/storeError'
import loggerLocal from '@/utils/loggerLocal'
import { type IntCredentials } from '@functions/models/interfaces/intCredentials'
import { getAnalytics, logEvent } from 'firebase/analytics'

//import { PasswordPolicyDocument, UserSignUpDocument } from '../graphql/types/graphql';
import { useStoreAuth } from '@/stores/storeAuth'
import { useStoreUser } from '@/stores/storeUser'



import { FirebaseError } from '@firebase/util'


import { i18nGlobal } from '@/i18n'
import { routesName } from '@/plugins/router'
import { showErrorMessage, showMessage, showSuccessUpdateMessage } from '@/utils/showMessage'
import { DBProcess, DBProviderType, DBRetCode } from '@functions/models/DBEnum'
import type { IOChangePasswordRequest } from '@functions/models/ioInterfaces/ioChangePassword'
import type { IOSignUpRequest } from '@functions/models/ioInterfaces/ioSignUp'
import {
  type Auth,
  EmailAuthProvider,
  FacebookAuthProvider,
  GoogleAuthProvider,
  OAuthProvider,
  type User,
  type UserCredential,
  browserLocalPersistence,
  browserSessionPersistence,
  confirmPasswordReset,
  createUserWithEmailAndPassword,
  getAuth,
  getIdToken,
  onAuthStateChanged,
  reauthenticateWithCredential,
  sendEmailVerification,
  sendPasswordResetEmail,
  setPersistence,
  signInWithEmailAndPassword,
  signInWithPopup,
  updatePassword,
  verifyPasswordResetCode
} from 'firebase/auth'
import { getCurrentUser } from 'vuefire'
import { be_signUpUser } from './backEndCaller'
import { getUserData } from './user'
/*
import { RoutesNames } from '@/router/routesNames';
import { getUser } from './user';
import { logoutCustomerly } from '@/plugins/customerly';
import mutation from '@/graphql/mutation';
import query from '@/graphql/query';
import { resetStore } from '@/stores';
import router from '@/router';
import { useDialogsStore } from '@/stores/dialogs';
import { useErrorStore } from '@/stores/error';
import { useOnboardingStore } from '@/stores/onboarding';
import { useUserStore } from '@/stores/user';
*/

export async function checkSession () {
  loggerLocal.info( 'checkSession start' )
  const userStore = useStoreUser()
  userStore.fetching = true
  loggerLocal.info( 'checkSession userStore', userStore )
  //const token = await getCurrentSession()
  const token = await waitForAuthReady()
  loggerLocal.info( 'checkSession token', token )
  //console.log('token',token);
  if ( token )
  {
    loggerLocal.info( 'checkSession token EXIST', token )
    //await getUser(callback);
    return true
  } else
  {
    loggerLocal.info( 'checkSession token NOT EXIST', token )
    userStore.fetching = false
    return false
  }
}

/*export async function getCurrentSession (): Promise<string | undefined> {
  try
  {
    //console.log('getCurrentSession start')
    //const user = getAuth().currentUser;
    loggerLocal.info( 'getCurrentSession->start' )
    //const currentUser = await getCurrentUser()
    //const init = await initializeFirebase()
    //const auth = init.auth
    const auth = getAuth()
    const currentUser = auth.currentUser;
    //const currentToken = await waitForAuthReady()
    if ( currentUser != null )
    {
      return getIdToken( currentUser )
    } else
    {
      return undefined
    }
  } catch ( error )
  {
    // console.error(error);
    return undefined
  }
}*/

export async function getCurrentSession (): Promise<string | undefined> {
  const auth = getAuth();

  return new Promise( ( resolve ) => {
    const unsubscribe = onAuthStateChanged( auth, async ( user ) => {
      unsubscribe(); // disiscrive subito dopo la prima risposta
      if ( user )
      {
        const token = await getIdToken( user );
        resolve( token );
      } else
      {
        resolve( undefined );
      }
    } );
  } );
}


export async function getAndStoreCurrentUserData (): Promise<User | undefined> {
  try
  {
    const currentUser = await getCurrentUser()
    loggerLocal.info( 'currentUser', currentUser )

    if ( currentUser != null )
    {
      const storeAuth = useStoreAuth()
      storeAuth.setStoreUser( currentUser )
      return currentUser
    } else
    {
      return undefined
    }
  } catch ( error )
  {
    // console.error(error);
    showErrorMessage( undefined, error )
    return undefined
  }
}

export async function getUserById ( id: string ): Promise<User | undefined> {
  try
  {
    const auth = getAuth()
    //const user = auth.getUser(id)
    // return user
  } catch ( error )
  {
    //console.error(error);
    return undefined
  }
}

export async function signinUser ( email: string, password: string, rememberMe: boolean ): Promise<UserCredential | boolean> {
  try
  {
    loggerLocal.info( 'signinUser input', email, password, rememberMe );
    const auth = getAuth();

    const persistence = rememberMe ? browserLocalPersistence : browserSessionPersistence;
    await setPersistence( auth, persistence );
    loggerLocal.info( 'Persistence set to', rememberMe ? 'LOCAL' : 'SESSION' );

    const res = await signInWithEmailAndPassword( auth, email, password );
    loggerLocal.info( 'signinUser res', res );
    return res;

  } catch ( error: any )
  {
    loggerLocal.error( 'error signing in', error );
    firestoreAuthErr( error, DBProcess.SIGNIN );

    if ( error.code === 'auth/wrong-password' || error.code === 'auth/user-not-found' )
    {
      showErrorMessage( i18nGlobal.t( 'auth.userOrPasswordWrong' ) as string, DBRetCode.ERROR );
    } else
    {
      showErrorMessage( error.message || 'Unknown error', DBRetCode.ERROR );
    }

    return false;
  }
}


export async function signoutUser (): Promise<boolean> {
  try
  {
    const storeUser = useStoreUser()

    // await stopCheckVersion()
    await getAuth().signOut()
    storeUser.clearStore()

    /*        resetStore();
        logoutCustomerly();
        router.replace({ name: RoutesNames.onboarding_start });
*/ return true
  } catch ( error )
  {
    //console.log(error)
    loggerLocal.error( 'error signing out', error )
    firestoreAuthErr( error, DBProcess.SIGNOUT )
    return false
  }
}

export async function resetPassword ( email: string ): Promise<boolean> {
  try
  {
    const auth = getAuth()
    //const res = await sendPasswordResetEmail(auth, email, { url: window.location.origin })
    sendPasswordResetEmail( auth, email, { url: window.location.origin } )
      .then( () => {
        // Password reset email sent!
        // ..
        loggerLocal.info( 'resetPassword sent', email )
        showMessage( i18nGlobal.t( 'auth.resetPwdSent' ) as string )
      } )
      .catch( error => {
        const errorCode = error.code
        const errorMessage = error.message
        loggerLocal.error( 'error reset password in', error )
        firestoreAuthErr( error, DBProcess.SETNEWPASSWORD )

        // ..
      } )

    return true
  } catch ( error )
  {
    loggerLocal.error( 'error reset password in', error )
    firestoreAuthErr( error, DBProcess.SETNEWPASSWORD )
    return false
  }
}

export async function sendVerificationEmailFunc () {
  const auth = getAuth()
  loggerLocal.info( 'sendVerificationEmailFunc start', auth )
  const url = window.location.origin + '/' + routesName.home
  if ( auth )
  {
    await sendEmailVerification( ( auth as Auth ).currentUser as User, { url } )
      .then( () => {
        loggerLocal.info( 'sendEmailVerification' )
      } )
      .catch( error => {
        const errorCode = error.code
        const errorMessage = error.message
        loggerLocal.error( 'errorMessage', errorMessage )
        firestoreAuthErr( error, DBProcess.SIGNUP )
      } )
  }
}

export async function checkPasswordResetCode ( actionCode: string ): Promise<string> {
  try
  {
    const email = await verifyPasswordResetCode( getAuth(), actionCode )
    return email
  } catch ( error )
  {
    loggerLocal.error( 'error reset password code', error )
    firestoreAuthErr( error, DBProcess.SETNEWPASSWORD )
    return ''
  }
}

export async function setNewPassword ( actionCode: string, newPassword: string ): Promise<boolean> {
  try
  {
    await confirmPasswordReset( getAuth(), actionCode, newPassword )
    return true
  } catch ( error )
  {
    loggerLocal.error( 'error setting new password', error )
    firestoreAuthErr( error, DBProcess.SETNEWPASSWORD )
    return false
  }
}

export async function getProviderUser (): Promise<User | undefined> {
  try
  {
    //console.log('getCurrentSession start')
    //const user = getAuth().currentUser;
    const currentUser = await getCurrentUser()
    //console.log('getCurrentSession->user', currentUser);
    if ( currentUser != null )
    {
      return currentUser
    } else
    {
      return undefined
    }
  } catch ( error )
  {
    // console.error(error);
    return undefined
  }
}

export async function registerUser ( credentials: IntCredentials ) {
  const functionName = registerUser.name
  const auth = getAuth()

  loggerLocal.info( 'registerUser input', credentials )

  await createUserWithEmailAndPassword( auth as Auth, credentials.email, credentials.password )
    .then( async userCredential => {
      // Signed in
      //if (isNewDB()) {
      const user = await getProviderUser()
      const signUpReq: IOSignUpRequest = {
        providerId: user?.uid as string,
      }
      const res = await be_signUpUser( signUpReq )
      const analytics = getAnalytics()
      logEvent( analytics, 'signup', { name: functionName } )
      loggerLocal.info( 'res', res )
    } )
    .catch( error => {
      const errorCode = error.code
      const errorMessage = error.message
      loggerLocal.error( 'registerUser errorMessage', errorMessage )
      firestoreAuthErr( error, DBProcess.SIGNUP )
    } )

  if ( auth )
  {
    await sendVerificationEmailFunc()
    return true
  } else
  {
    return false
  }
}

function getProvider ( providerType: DBProviderType ) {
  switch ( providerType )
  {
    case DBProviderType.GOOGLE:
      return new GoogleAuthProvider()
    case DBProviderType.FACEBOOK:
      return new FacebookAuthProvider()
    case DBProviderType.GITHUB:
      return new GoogleAuthProvider()
    case DBProviderType.MICROSOFT:
      return new OAuthProvider( 'microsoft.com' )
    case DBProviderType.APPLE:
      return new OAuthProvider( 'apple.com' )
    default:
      return new GoogleAuthProvider()
  }
}

export interface ISignupProviderResponse {
  res: boolean
  userExist: boolean
}

export async function signInUpProvider ( providerType: DBProviderType ): Promise<ISignupProviderResponse> {
  loggerLocal.info( 'providerType', providerType )
  const functionName = 'signInUpProvider'
  const provider = await getProvider( providerType )
  loggerLocal.info( 'provider', provider.toString() )
  const storeAuth = useStoreAuth()
  const storeUser = useStoreUser()
  const auth = getAuth()
  const output: ISignupProviderResponse = {
    res: false,
    userExist: false,
  }
  const res = await signInWithPopup( auth, provider )
    //const res = await signInWithRedirect(auth, provider)
    .then( async result => {
      // User is signed in.
      // IdP data available in result.additionalUserInfo.profile.

      // Get the OAuth access token and ID Token
      const credential =
        providerType == DBProviderType.GOOGLE
          ? GoogleAuthProvider.credentialFromResult( result )
          : OAuthProvider.credentialFromResult( result )
      //const accessToken = credential.accessToken
      //const idToken = credential.idToken
      if ( credential )
      {
        const token = credential.accessToken
        const currentUser = result.user
        loggerLocal.info( 'currentUser', currentUser )

        if ( currentUser )
        {
          //if (isNewDB()) {
          let userData = await getUserData( currentUser.uid )

          loggerLocal.info( 'userData', userData )
          if ( userData )
          {
            if ( !userData.isRegistered )
            {
              const user = await getProviderUser()
              const signUpReq: IOSignUpRequest = {
                providerId: user?.uid as string,
              }

              const res = await be_signUpUser( signUpReq )
              if ( res )
              {
                userData = await getUserData( ( user as User ).uid as string )
                const analytics = getAnalytics()
                logEvent( analytics, 'signup', { name: functionName } )
                output.res = true
                if ( !res.emailVerified )
                {
                  await sendVerificationEmailFunc()
                }
              }
            } else
            {
              output.res = true
            }
          }

          output.res = false
        }
        // The signed-in user info.
        else
        {
          loggerLocal.error( '1.0 Missing credentials for ' + providerType )
          output.res = false
        }
      } else
      {
        loggerLocal.error( '2.0 Missing credentials for ' + providerType )
        output.res = false
      }
    } )
    .catch( async error => {
      loggerLocal.error( '2.0 error ' + providerType, error )
      //loggerLocal.error('2.1 error ', error.code)
      if ( error?.code == 'auth/account-exists-with-different-credential' )
      {
        //loggerLocal.error('2.2.0 error ', error.code)
        const email = error?.customData?.email

        showErrorMessage( i18nGlobal.t( 'auth.errAccountExists', { account: email } ) as string, 'Error' )
        output.userExist = true
        //const pendingCredential: AuthCredential = error?.credential
        //loggerLocal.error('2.2.2 error userSignInMethods ', email, pendingCredential)
      }
      output.res = false
      // Handle error.
    } )
  loggerLocal.info( 'res', res )
  return output
}



export async function changePassword ( p: IOChangePasswordRequest ) {
  const auth = getAuth()
  const user = auth.currentUser

  if ( p.newPassword !== p.confirmPassword )
  {
    const storeError = useStoreError()
    storeError.setError( i18nGlobal.t( 'pwdNotMatch' ) )
    return false
  }
  const credentials = EmailAuthProvider.credential( auth.currentUser?.email as string, p.oldPassword )

  try
  {
    try
    {
      const resAuth = await reauthenticateWithCredential( user as User, credentials )
      loggerLocal.info( 'resAuth', resAuth )
    } catch ( e )
    {
      showErrorMessage( i18nGlobal.t( 'auth.errPasswordNotValid' ) as string, e )
    }
    const resNewPwd = await updatePassword( user as User, p.newPassword )
    showSuccessUpdateMessage()
    loggerLocal.info( 'resNewPwd', resNewPwd )
    return true
  } catch ( e )
  {
    firestoreAuthErr( e, DBProcess.CHANGEPASSWORD )
    return false
  }
}

export function firestoreAuthErr ( error: any, process: DBProcess ) {
  const storeError = useStoreError()
  loggerLocal.info( 'firestoreAuthErr', error, process )
  let errorToShow = error
  let errorMsg = ''
  switch ( process )
  {
    case DBProcess.SIGNIN:
    case DBProcess.SIGNINGoogle:
      errorMsg = i18nGlobal.t( 'auth.errSignIn' )
      break
    case DBProcess.SIGNUP:
      errorMsg = i18nGlobal.t( 'auth.errSignUp' )
      break
    case DBProcess.SETNEWPASSWORD:
      errorMsg = i18nGlobal.t( 'auth.errChangePwd' )
      break
    case DBProcess.CREATEUSER:
      errorMsg = i18nGlobal.t( 'auth.errCreateUser' )
      break
    case DBProcess.CHANGEPASSWORD:
      errorMsg = i18nGlobal.t( 'auth.errSetNewPwd' )
      break
    default:
      errorMsg = i18nGlobal.t( 'auth.errAuthProcess' )
      break
  }

  if ( error instanceof FirebaseError )
  {
    const err: FirebaseError = error
    switch ( err.code )
    {
      case 'auth/invalid-password':
      case 'auth/wrong-password':
      case 'auth/invalid-email':
      case 'auth/invalid-credential':
      case 'auth/email-not-found':
      case 'auth/user-not-found':
        errorMsg = i18nGlobal.t( 'auth.userOrPasswordWrong' ) as string
        errorToShow = err.code
        break
      case 'auth/invalid-phone-number':
        errorMsg = i18nGlobal.t( 'auth.wrongMobileNumber' ) as string
        errorToShow = err.code
        break
      case 'auth/too-many-requests':
        errorMsg = errorMsg = i18nGlobal.t( 'auth.tooManyRequests' ) as string
        break
      case 'auth/firebase-app-check-token-is-invalid':
        errorMsg = i18nGlobal.t( 'auth.firebaseAppCheckTokenInvalid' ) as string
        errorToShow = err.code
        break
    }
  }

  loggerLocal.error( 'firestoreAuthErr errorMsg', errorMsg, errorToShow )
  //storeError.setError(errorMsg, errorToShow)
  showErrorMessage( errorMsg, errorToShow )
}

export function waitForAuthReady (): Promise<string | undefined> {
  const auth = getAuth()

  return new Promise( ( resolve ) => {
    const unsubscribe = onAuthStateChanged( auth, async ( user ) => {
      unsubscribe() // evitiamo chiamate multiple

      if ( user )
      {
        const token = await user.getIdToken()
        resolve( token )
      } else
      {
        resolve( undefined )
      }
    } )
  } )
}

export function waitForUserReady (): Promise<User | null> {
  const auth = getAuth()
  return new Promise( resolve => {
    const unsubscribe = onAuthStateChanged( auth, user => {
      unsubscribe()
      resolve( user )
    } )
  } )
}